"use client";

import { useEffect, useState } from "react";
import { Menu, Facebook } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/30 animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {/* Desktop Menu */}
      <div className="hidden md:block">
        <NavigationMenu viewport={false}>
          <NavigationMenuList>
            {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
                <NavigationMenuLink asChild>
                  <Link to={item.href || "#"} className="text-foreground/90 hover:text-primary transition-colors duration-200">
                    {item.label}
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>)}
          </NavigationMenuList>
        </NavigationMenu>
      </div>

      {/* Mobile Menu Button */}
      <Button variant="ghost" size="icon" className="md:hidden text-foreground hover:text-primary" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        <Menu className="size-6" />
      </Button>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background/95 backdrop-blur-md border-b border-primary/20 md:hidden">
          <nav className="flex flex-col p-4 gap-2">
            {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-foreground/90 hover:text-primary transition-colors duration-200 py-2 px-3 rounded-md hover:bg-primary/10" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-background/98 shadow-medium" : "bg-background/95"} backdrop-blur-md border-b border-primary/20`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img src="https://rackemjoelivestream.net/wp-content/uploads/2025/12/logo1.png" alt="RackemJoe Live Stream" className="h-7 filter drop-shadow-[0_0_8px_hsla(4,95%,52%,0.3)] group-hover:drop-shadow-[0_0_12px_hsla(4,95%,52%,0.5)] transition-all duration-300" />
          </Link>

          {/* Navigation Menu */}
          <MenuProvider menu_id="3" className="flex-1 flex justify-center">
            <HeaderMenuConsumer />
          </MenuProvider>

          {/* Right Side Actions */}
          <div className="flex items-center gap-3">
            {/* Facebook Link */}
            <a href="https://www.facebook.com/rackemjoe/" target="_blank" rel="noopener noreferrer" className="text-foreground/80 hover:text-primary transition-colors duration-200" aria-label="Visit our Facebook page">
              <Facebook className="size-5" />
            </a>

            {/* Watch Live Button */}
            <Button asChild className="bg-transparent border-2 border-primary text-primary hover:bg-primary hover:text-foreground-primary shadow-[0_0_8px_hsla(4,95%,52%,0.3)] hover:shadow-[0_0_12px_hsla(4,95%,52%,0.6)] hover:scale-[1.03] transition-all duration-[120ms] ease-out">
              <Link to="/LiveStreamPage">Watch Live</Link>
            </Button>
          </div>
        </div>
      </div>
    </header>;
}